import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import SecondaryListItem from "./SecondaryListItem";
import { ISidebarItem } from "../Routes";
import { useOrders } from "../util/OrderContext";
import * as URLS from "../../const/URL.const";

const textPrimary = "#2C2C2C";
const gutterWidth = "1vw";
const gutterHeight = "0.49vh";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ".MuiDrawer-paper": {
      position: "relative",
      ".MuiListItem-gutters": {
        "&.selected": {
          borderLeft: "4px solid #ffdd02",
          backgroundColor: "rgba(0, 0, 0, 0.03)",
        },
      },
    },
    secondaryList: {
      paddingLeft: gutterWidth,
      paddingRight: gutterWidth,
      "& .MuiTypography-body1": {
        fontSize: "1rem",
      },
      "& a": {
        display: "block",
        textDecoration: "none",
        color: textPrimary,
        padding: `${gutterHeight} 0`,

        "&:visited": {
          color: textPrimary,
        },
      },
    },
  })
);

interface ISecondaryList {
  isLoading: boolean;
  selected: string;
  item: ISidebarItem;
}

const SecondaryList = ({ isLoading, selected, item }: ISecondaryList) => {
  const classes = useStyles();
  const { newOrders, openedOrders } = useOrders()!;
  const isOpenOrders = item.key === "OPEN_ORDERS"

  return (
    <div className={classes.secondaryList}>
      <SecondaryListItem
        title={`sidebarSecondaryMenu.${isOpenOrders ? "openOrders" : "newOrders"}`}
        loading={isLoading}
        isSelected={selected === item.key}
        count={isOpenOrders ? openedOrders.length : newOrders.length}
        url={isOpenOrders ? URLS.OPEN_ORDERS_URL : URLS.NEW_ORDERS_URL}
        dataComponentName={item.key}
      />
    </div>
  );
};

export default SecondaryList;
